<template>
  <div>
    <div v-for="row1 in arr" :key="row1.id">
      <ul>
        <li
          v-for="(child1, index1) in getRelatedWebsites(row1.children, tag)"
          :key="`sub-${child1}-${index1}`"
        >
          {{ child1.name }} / {{ tag }}
          <ul>
            <li
              v-for="(child2, index2) in getRelatedWebsites(
                child1.children,
                tag
              )"
              :key="`sub-page-${child2}-${index2}`"
            >
              {{ child2.name }}
              <ul>
                <li
                  v-for="(child3, index3) in getRelatedWebsites(
                    child2.children,
                    tag
                  )"
                  :key="`sub-sub-page-${child3}-${index3}`"
                >
                  {{ child3.name }}
                  <ul>
                    <li
                      v-for="(child4, index4) in getRelatedWebsites(
                        child3.children,
                        tag
                      )"
                      :key="`sub-sub-sub-page-${child4}-${index4}`"
                    >
                      {{ child4.name }}
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "NamingWebsiteNested",
  data() {
    return {};
  },
  props: {
    arr: {
      type: Array,
      default: () => [],
    },
    tag: {
      type: String,
      default: "Standalone",
    },
  },
  watch: {},
  computed: {},

  methods: {
    getRelatedWebsites(arr, key) {
      const temp = [];
      arr.forEach((element) => {
        const testArray = element.websites;
        if (testArray.includes(key)) {
          temp.push(element);
        }
      });
      return temp;
    },
  },
};
</script>

<style lang="scss">
.website-box {
  text-align: left;
  .browser {
    width: 300px;
    height: 200px;
    border-top: 12px solid gray;
    border-bottom: 1px solid gray;
    border-left: 1px solid gray;
    border-right: 1px solid gray;
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ul {
    padding-left: 0;
    margin-left: 0;
    li {
      margin-left: 1.4rem;
      text-align: left;
    }
  }
}
</style>
